import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { FlashList } from '@shopify/flash-list';
import { AppView, SCREEN_BOTTOM_PADDING, Spacer, withAnimatedNavigationHeader, } from 'design-system';
import ListEmptyView from 'design-system/ListEmptyView';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useAppSelector } from 'store/hooks';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import useEnsureData from 'hooks/useEnsureData';
import CreditScoreEnhancedFactorCard from '../components/CreditScoreEnhancedFactorCard';
import { selectCreditScoreFactors, selectHasEnhancedFactors, } from '../selectors';
import { getEnhancedFactors } from '../actions';
import { isPositiveFactor } from '../utils';
import { isWeb } from '../../../constants';
const strings = {
    headerTitle: 'Credit health factors',
    emptyTitle: 'No credit factors yet',
    emptySubTitle: "We don't have any credit factors to show right now. Check back once your credit score has been updated.",
};
const AnimatedFlashList = Animated.createAnimatedComponent(FlashList);
const keyExtractor = (item) => String(item.id);
const CreditScoreEnhancedCreditFactors = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    useEnsureData(selectHasEnhancedFactors, getEnhancedFactors);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    const factors = useAppSelector(selectCreditScoreFactors);
    const renderItem = useCallback(({ item }) => {
        const isPositive = isPositiveFactor(item.factorColor);
        return (<CreditScoreEnhancedFactorCard positiveFactor={isPositive} title={item.type} subTitle={item.message}/>);
    }, []);
    const ListEmptyComponent = useMemo(() => (<ListEmptyView onCard happy title={strings.emptyTitle} subTitle={strings.emptySubTitle}/>), []);
    if (isWeb) {
        return (<AppView withFrame={false}>
            <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} showsVerticalScrollIndicator contentContainerStyle={contentContainerStyle}>
              <Spacer.H16 />
              {factors.length === 0
                ? ListEmptyComponent
                : factors.map((item) => (<CreditScoreEnhancedFactorCard key={keyExtractor(item)} positiveFactor={isPositiveFactor(item.factorColor)} title={item.type} subTitle={item.message}/>))}
            </Animated.ScrollView>
          </AppView>);
    }
    return (<AppView withFrame={false}>
          <AnimatedFlashList data={factors} renderItem={renderItem} keyExtractor={keyExtractor} onScroll={scrollHandler} scrollEventThrottle={16} showsVerticalScrollIndicator contentContainerStyle={contentContainerStyle} ListHeaderComponent={<Spacer.H16 />} ListEmptyComponent={ListEmptyComponent}/>
        </AppView>);
}, ({ colors }) => ({
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default CreditScoreEnhancedCreditFactors;
